import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogDefinitionEditorBase} from '@shared/components/platform-tool/platform-tool-dialog-definition/models/dialog-defnition-models';

@Component({
    standalone: false,
    selector: 'app-dialog-field-html-renderer',
  templateUrl: './dialog-field-html-renderer.component.html',
  styleUrls: ['./dialog-field-html-renderer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogFieldHtmlRendererComponent extends DialogDefinitionEditorBase implements OnInit {

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
